/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface GetMenuItemsForSubvenue$Params {
  subVenueId?: string;
  selectedDate?: string;
}

export function getMenuItemsForSubvenue(http: HttpClient, rootUrl: string, params?: GetMenuItemsForSubvenue$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, getMenuItemsForSubvenue.PATH, 'get');
  if (params) {
    rb.query('subVenueId', params.subVenueId, {});
    rb.query('selectedDate', params.selectedDate, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

getMenuItemsForSubvenue.PATH = '/api/mng/Venue/getmenuitemsforsubvenue';
